export default "__VITE_ASSET__Dfr5It_p__"